/* tslint:disable */

declare var Object: any;
export interface FacturasGlobalesInterface {
  "fecha"?: Date;
  "fechaOperaciones"?: Date;
  "recibos"?: Array<any>;
  "cfdiXml"?: string;
  "sello"?: string;
  "timbreData"?: any;
  "cfdi"?: any;
  "id"?: any;
}

export class FacturasGlobales implements FacturasGlobalesInterface {
  "fecha": Date;
  "fechaOperaciones": Date;
  "recibos": Array<any>;
  "cfdiXml": string;
  "sello": string;
  "timbreData": any;
  "cfdi": any;
  "id": any;
  constructor(data?: FacturasGlobalesInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `FacturasGlobales`.
   */
  public static getModelName() {
    return "FacturasGlobales";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of FacturasGlobales for dynamic purposes.
  **/
  public static factory(data: FacturasGlobalesInterface): FacturasGlobales{
    return new FacturasGlobales(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'FacturasGlobales',
      plural: 'FacturasGlobales',
      path: 'FacturasGlobales',
      idName: 'id',
      properties: {
        "fecha": {
          name: 'fecha',
          type: 'Date'
        },
        "fechaOperaciones": {
          name: 'fechaOperaciones',
          type: 'Date'
        },
        "recibos": {
          name: 'recibos',
          type: 'Array&lt;any&gt;'
        },
        "cfdiXml": {
          name: 'cfdiXml',
          type: 'string'
        },
        "sello": {
          name: 'sello',
          type: 'string'
        },
        "timbreData": {
          name: 'timbreData',
          type: 'any'
        },
        "cfdi": {
          name: 'cfdi',
          type: 'any'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}
